/**
 * デバイス判定
 * @returns {'iphone' | 'ipad' | 'android' | 'other'}
 */
function detectDevice() {
  if (navigator.userAgentData) {
    const { platform, mobile } = navigator.userAgentData;
    if (platform === 'iOS' && mobile) return 'iphone';
    if (platform === 'iOS' && !mobile) return 'ipad';
    if (platform === 'Android') return mobile ? 'android' : 'other';
    return 'other';
  }
  const ua = navigator.userAgent;
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const isIpad = /iPad/.test(ua) || (/Macintosh/.test(ua) && isTouch);
  if (/iPhone/.test(ua)) return 'iphone';
  if (/Android/.test(ua)) return /Mobile/.test(ua) ? 'android' : 'other';
  if (isIpad) return 'ipad';
  return 'other';
}
